<template>
  <div class="mobile container">
    <!--<div class="row">
      <div class="col-12 right">
        <a href="https://www.swiss-skills.ch/" target="_blank">{{ $t("tan.help.help_faq") }}</a>
      </div>
    </div>-->
    <div class="row vertical-center">
      <div class="col-12 left">
        <h1 style="text-align: center">{{ $t("mobile.caption") }}</h1>
        <p>{{ $t("mobile.message") }}</p>
        <!--<p>
          <img src="../assets/tablet-und-laptop.png" alt="Laptop und Tablet" />
        </p>-->
        <div class="row, right">
          <button class="btn btn-primary" @click="next"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Mobile",
  methods: {
    next() {
      this.$router.push("/tan")
    },
  },
}
</script>

<style scoped>
.center {
  text-align: center;
}
img {
  width: 100%;
  max-width: 200px;
  height: auto;
  margin-top: 20px;
  margin-bottom: 30px;
}
h1 {
  background-color: #e5efef;
  padding: 10px;
  color: #006265;
}
.btn {
  border-radius: 50% !important;
  height: 100px !important;
  width: 100px !important;
  font-size: 0px !important;
}

.btn-primary {
  border-color: white !important;
  background-color: white !important;
  max-width: 100px;
  max-height: 100px;
  background-image: url("../assets/web_button.png");
  background-repeat: no-repeat;
  background-size: cover;
}
@media screen and (max-width: 770px) and (orientation: landscape) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
@media screen and (max-width: 770px) and (orientation: portrait) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
</style>